module.exports = __webpack_public_path__ + "img/dashboard-edit.1a9ed354.png";